import { parse as dateFnsParse } from 'date-fns'
import { enUS as en, es, fr } from 'date-fns/locale'
import { useCallback, useMemo } from 'react'
import { useIntl } from 'react-intl'

type SupportedLocales = 'en' | 'es' | 'fr'
type DateFunctions = {
  parseDateLocal: (date: string) => Date
  validateTimezone: (tz?: string) => boolean
}

const locales = {
  en,
  es,
  fr,
}

export default function useDateParsers(): DateFunctions {
  const { locale } = useIntl()

  const parse = useCallback(
    (date: string, format: string): Date =>
      dateFnsParse(date, format, new Date(), {
        locale: locales[locale as SupportedLocales] || locales.en,
      }),
    [locale],
  )

  return useMemo(
    () => ({
      parseDateLocal: (date: string) => parse(date, 'PP'),
      validateTimezone: (tz: string) => {
        try {
          Intl.DateTimeFormat(undefined, { timeZone: tz })
          return true
        } catch (e) {
          return false
        }
      },
    }),
    [parse],
  )
}
